export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10283.267727cf.jpg";